import request from '@/utils/request'
import host from '@/api/base/host'
import { encryptAES_H5, getRequestKey, decryptAES_H5 } from '@/utils'

// 用户登录
const login = host.path('dev', { dev: 'v2/login' })
const user = host.path('dev', { dev: 'v1/user' })
const user2 = host.path('dev', { dev: 'v2/user' })
    // const loginH5 = host.path('dev', { dev: 'v1/login/h5' })
export default {
    getCode(data) {
        data.areaCode = encryptAES_H5(data.areaCode, getRequestKey())
        data.mobileNumber = encryptAES_H5(data.mobileNumber, getRequestKey())
        return request({ url: login('h5/getVerificationCode'), method: 'post', data })
    },
    checkCode(data) {
        data.areaCode = encryptAES_H5(data.areaCode, getRequestKey())
        data.mobileNumber = encryptAES_H5(data.mobileNumber, getRequestKey())
        data.verificationCode = encryptAES_H5(data.verificationCode, getRequestKey())
        delete data.isBrowser
        delete data.randStr
        delete data.ticket
        delete data._expire
        delete data.v
        return request({ url: login('h5/checkVerificationCode'), method: 'post', data })
    },
    // 用户信息
    getUserDetail(data) {
        return request({ url: user2('myinfo/h5/getUserInfo'), method: 'post', data })
    },
    // 查询会员有效期状态
    getAccountState(data) {
        return request({ url: user('myinfo/my'), method: 'post', data })
    }
}